<template lang="html">
  <div>
    <v-card
      outlined
      class="konfigurasi"
      :class="{'konfigurasi--kosong': !loading && !konfigurasi}"
      :style="{borderLeft: '4px solid ' + $vuetify.theme.currentTheme[konfigurasi ? 'success' : 'warning']}"
    >
      <v-skeleton-loader v-if="loading" type="list-item-avatar-two-line"></v-skeleton-loader>

      <div v-else class="d-flex align-center flex-wrap pa-3">
        <v-avatar size="44" :color="konfigurasi ? 'success' : 'warning'" class="mr-3">
          <v-icon dark>{{konfigurasi ? 'mdi-account-check' : 'mdi-account-alert'}}</v-icon>
        </v-avatar>

        <div class="konfigurasi__info mr-3">
          <div class="overline grey--text text--darken-1 konfigurasi__label">Verifikator Aktivitas</div>
          <template v-if="konfigurasi">
            <div class="subtitle-1 font-weight-medium konfigurasi__nama">{{getNama(verifikator) || konfigurasi.nip_verifikator}}</div>
            <div class="caption grey--text text--darken-1">
              {{getKeterangan(verifikator, konfigurasi.nip_verifikator)}}
              <span v-if="konfigurasi.updated_at"> &bull; Diperbarui {{konfigurasi.updated_at | formatWaktu}}</span>
            </div>
          </template>
          <template v-else>
            <div class="subtitle-1 font-weight-medium konfigurasi__nama">Verifikator aktivitas belum diatur</div>
            <div class="caption grey--text text--darken-1">Tentukan atasan yang akan memverifikasi laporan aktivitas Anda</div>
          </template>
        </div>

        <v-spacer></v-spacer>

        <v-btn v-if="konfigurasi" small text color="primary" class="my-1" @click="openDialog">
          <v-icon small left>mdi-pencil</v-icon> Ubah
        </v-btn>
        <v-btn v-else small color="warning" class="my-1" @click="openDialog">
          <v-icon small left>mdi-account-plus</v-icon> Atur Verifikator
        </v-btn>
      </div>
    </v-card>

    <v-dialog v-model="dialog" max-width="480px">
      <v-card>
        <v-card-title class="display-1 orange--text">Verifikator Aktivitas</v-card-title>
        <v-card-text>
          <p class="paragraph">Cari atasan yang akan memverifikasi aktivitas Anda. NIP atau ID jabatan harus sama persis.</p>

          <v-btn-toggle v-model="mode" mandatory dense color="primary" class="d-flex mb-4">
            <v-btn value="pegawai" class="flex-grow-1">
              <v-icon small left>mdi-account</v-icon> Pegawai (NIP)
            </v-btn>
            <v-btn value="jabatan" class="flex-grow-1">
              <v-icon small left>mdi-account-tie</v-icon> PLT (ID Jabatan)
            </v-btn>
          </v-btn-toggle>

          <v-text-field
            v-model="keyword"
            outlined
            dense
            autofocus
            :label="mode == 'pegawai' ? 'NIP Atasan' : 'ID Jabatan PLT'"
            :counter="mode == 'pegawai' ? 18 : false"
            :hint="mode == 'pegawai' ? 'Masukkan 18 digit NIP lalu tekan Enter' : 'Masukkan ID jabatan lalu tekan Enter'"
            persistent-hint
            :error-messages="inputError"
            :loading="loadingCari"
            append-icon="mdi-magnify"
            @click:append="cari"
            @keyup.enter="cari"
          ></v-text-field>

          <v-card v-if="hasil" outlined class="mt-2 konfigurasi__hasil">
            <div class="d-flex align-center pa-3">
              <v-avatar size="40" color="primary" class="mr-3">
                <v-icon dark>{{hasil.jabatan_id && !hasil.peg_nip ? 'mdi-account-tie' : 'mdi-account'}}</v-icon>
              </v-avatar>
              <div class="konfigurasi__info">
                <div class="font-weight-medium">{{getNama(hasil)}}</div>
                <div class="caption grey--text text--darken-1">{{getKeterangan(hasil)}}</div>
              </div>
              <v-spacer></v-spacer>
              <v-icon color="success">mdi-check-circle</v-icon>
            </div>
          </v-card>

          <v-alert v-else-if="tidakDitemukan" dense text type="warning" class="caption mt-2 mb-0">
            Data tidak ditemukan, pastikan {{mode == 'pegawai' ? 'NIP' : 'ID jabatan'}} sama persis.
          </v-alert>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-btn @click="dialog = false">Batal</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="success" :loading="loadingSimpan" :disabled="!hasil" @click="simpan">Simpan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import _g from '@/global'
import store from '@/store'
import moment from 'moment'
import AktivitasService from '@/services/AktivitasService'

export default {
  data: () => ({
    loading:false,
    konfigurasi:null,
    verifikator:null,
    dialog:false,
    mode:'pegawai',
    keyword:'',
    hasil:null,
    tidakDitemukan:false,
    inputError:'',
    loadingCari:false,
    loadingSimpan:false,
  }),

  filters:{
    formatWaktu: function(value){
      moment.locale('id')
      return moment(value).format('D MMMM YYYY')
    },
  },

  watch:{
    keyword(){
      this.resetHasil()
    },

    mode(){
      this.keyword = ''
      this.resetHasil()
    }
  },

  created(){
    this.load()
  },

  methods:{
    load(){
      this.loading = true

      AktivitasService.getKonfigurasiAktivitas().then(response => {
        let data = response.data.data
        this.konfigurasi = data && data.nip_verifikator ? data : null
        if (this.konfigurasi){
          return this.resolveVerifikator(this.konfigurasi.nip_verifikator)
        }
      }).catch(() => {
        this.konfigurasi = null
      }).finally(() => {
        this.loading = false
      })
    },

    // lengkapi nama & jabatan verifikator, NIP 18 digit = pegawai, selain itu = PLT-{id jabatan}
    resolveVerifikator(nip){
      this.verifikator = null
      let search = String(nip).length == 18 ? AktivitasService.searchPegawai(nip) : AktivitasService.searchJabatan(String(nip).replace(/^PLT-/i, ''))

      return search.then(response => {
        this.verifikator = response.data.data || null
      }).catch(() => {
        this.verifikator = null
      })
    },

    getNama(item){
      if (!item){
        return ''
      }
      return item.peg_nama || item.jabatan_nama || ''
    },

    getKeterangan(item, nip){
      if (!item){
        return nip ? (String(nip).length == 18 ?  nip : 'PLT • ID Jabatan ' + String(nip).replace(/^PLT-/i, '')) : ''
      }
      if (item.peg_nip){
        return [item.jabatan, item.golongan, item.peg_nip].filter(x => x).join(' • ')
      }
      return 'PLT • ID Jabatan ' + item.jabatan_id
    },

    openDialog(){
      this.mode = 'pegawai'
      this.keyword = ''
      this.resetHasil()
      this.dialog = true
    },

    resetHasil(){
      this.hasil = null
      this.tidakDitemukan = false
      this.inputError = ''
    },

    cari(){
      let keyword = (this.keyword || '').trim()
      this.resetHasil()

      if (!/^\d+$/.test(keyword)){
        this.inputError = 'hanya boleh angka'
        return
      }
      if (this.mode == 'pegawai' && keyword.length != 18){
        this.inputError = 'NIP harus 18 digit'
        return
      }
      if (keyword == _g.getCurrentUsername()){
        this.inputError = 'tidak bisa memilih diri sendiri sebagai verifikator'
        return
      }

      let mode = this.mode
      let search = mode == 'pegawai' ? AktivitasService.searchPegawai(keyword) : AktivitasService.searchJabatan(keyword)
      this.loadingCari = true

      search.then(response => {
        // abaikan response dari pencarian yang sudah berubah
        if (keyword != (this.keyword || '').trim() || mode != this.mode){
          return
        }
        let data = response.data.data
        if (data && (data.peg_nip || data.jabatan_id)){
          this.hasil = data
        } else {
          this.tidakDitemukan = true
        }
      }).catch(() => {
        this.tidakDitemukan = true
      }).finally(() => {
        this.loadingCari = false
      })
    },

    getErrorMessage(error, fallback){
      let data = error.response ? error.response.data : null
      if (!data){
        return fallback
      }

      let errors = data.errors
      if (errors && typeof errors == 'object'){
        errors = _.flatten(Object.values(errors))[0]
      }
      return errors || data.message || fallback
    },

    simpan(){
      if (!this.hasil){
        return
      }
      // verifikator PLT disimpan dengan format PLT-{id jabatan}
      let nipAtasan = this.hasil.peg_nip ? String(this.hasil.peg_nip) : 'PLT-' + this.hasil.jabatan_id
      this.loadingSimpan = true

      AktivitasService.simpanKonfigurasiAktivitas(nipAtasan).then(response => {
        let data = response.data
        if (!data.errors){
          store.commit('snackbar/setSnack',{message:data.message || 'Verifikator aktivitas berhasil disimpan', color:'success'})
          this.dialog = false
          this.load()
        } else {
          store.commit('snackbar/setSnack',{message:this.getErrorMessage({response:response}, 'Verifikator aktivitas gagal disimpan'), color:'error'})
        }
      }).catch(error => {
        store.commit('snackbar/setSnack',{message:this.getErrorMessage(error, 'Verifikator aktivitas gagal disimpan'), color:'error'})
      }).finally(() => {
        this.loadingSimpan = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .konfigurasi{
    overflow: hidden;
    &--kosong{
      background-color: rgba(251, 140, 0, 0.06);
    }
    &__info{
      min-width: 0;
      flex: 1 1 220px;
    }
    &__label{
      line-height: 1.4;
    }
    &__nama{
      line-height: 1.3;
      overflow-wrap: anywhere;
    }
    &__hasil{
      border-color: #4caf50;
    }
  }
</style>
